module.exports = __webpack_public_path__ + "img/first-canadian-tire-protection-stock.9a993fbd.png";